import { Component, Input } from '@angular/core';
import { GlossaryTerm } from '../../../services/glossary.service';

/**
 * Card pequeño para un KPI individual.
 * Muestra título, valor grande, y subtítulo/descripción opcional.
 *
 * Uso típico:
 *   <app-metric-card title="MMRE" [value]="0.18" suffix="" subtitle="Error medio relativo"
 *                    semantic="good"></app-metric-card>
 *
 * Con tooltip didáctico:
 *   <app-metric-card title="P50" [value]="42" suffix="H" tooltipTerm="p50"></app-metric-card>
 */
@Component({
  selector: 'app-metric-card',
  templateUrl: './metric-card.component.html',
  styleUrls: ['./metric-card.component.scss']
})
export class MetricCardComponent {
  @Input() title: string = '';
  @Input() value: number | string | null = null;

  /** Sufijo a mostrar pegado al valor: 'H', '%', 'tokens', etc. */
  @Input() suffix: string = '';

  /** Texto descriptivo bajo el valor. */
  @Input() subtitle: string = '';

  /** Color semántico del valor: neutral por defecto. */
  @Input() semantic: 'neutral' | 'good' | 'warning' | 'danger' = 'neutral';

  /** Si se pasa un término del glosario, añade un icono ⓘ junto al título. */
  @Input() tooltipTerm?: GlossaryTerm;

  /** Si se pasa un texto literal, prevalece sobre tooltipTerm. */
  @Input() tooltipText?: string;

  /** Tamaño del card. 'lg' es para KPIs muy destacados. */
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  get hasValue(): boolean {
    return this.value !== null && this.value !== undefined && this.value !== '';
  }

  get displayValue(): string {
    if (!this.hasValue) return '—';
    if (typeof this.value === 'number') {
      return this.value.toLocaleString('es-ES', { maximumFractionDigits: 2 });
    }
    return String(this.value);
  }
}
